// components/dashboard/DashboardChart.jsx

import React from "react";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer
} from "recharts";

export default function DashboardChart({ data }) {
  const totalVentas = data.reduce((acc, d) => acc + d.total, 0);

  return (
    <div className="bg-white shadow-md rounded-xl p-6 border border-gray-200 w-full">
      <h2 className="text-2xl font-semibold mb-4 text-gray-800">Ventas por Fecha</h2>

      <p className="text-sm text-gray-600 mb-4">
        Total vendido: <span className="font-bold text-green-600">${totalVentas.toFixed(2)}</span>
      </p>

      {data.length > 0 ? (
        <ResponsiveContainer width="100%" height={300}>
          <AreaChart data={data}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="fecha" />
            <YAxis />
            <Tooltip
              content={({ active, payload }) => {
                if (active && payload && payload.length) {
                  return (
                    <div className="bg-white p-2 border rounded shadow text-sm">
                      <p>📅 Fecha: {payload[0].payload.fecha}</p>
                      <p>💰 Total: ${payload[0].value}</p>
                    </div>
                  );
                }
                return null;
              }}
            />
            <Area
              type="monotone"
              dataKey="total"
              stroke="#4f46e5"
              fill="#c7d2fe"
              isAnimationActive={true}
            />
          </AreaChart>
        </ResponsiveContainer>
      ) : (
        <p className="text-center text-gray-500 mt-6">No hay ventas registradas en este periodo.</p>
      )}
    </div>
  );
}
